<template>
  <v-container fluid>
    <v-row class="device_details" :class="!$route.params.deviceId ? '' : 'pl-3 pr-3'">
      <v-col cols="12" class="text-body-1 pt-0 pb-0 backgroundLight">
        <v-toolbar class="add-opacity" color="backgroundLight" :flat="true">
          <v-toolbar-title v-if="!$route.params.originId" class="title primaryGrey--text">
            <router-link :to="`/journey/${originId}/${destinationId}/${week}`">
              <v-icon class="mr-3" small color="primaryGrey">mdi-open-in-new</v-icon>Open as a Page
            </router-link>
          </v-toolbar-title>
          <v-toolbar-title v-if="$route.params.originId" class="title primaryGrey--text">
            <router-link :to="`/journeys`">
              <v-icon class="mr-3" color="primaryGrey">mdi-keyboard-backspace</v-icon>Back
            </router-link>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-col>
    </v-row>

    <v-row class="common-card-row">
      <v-col cols="12" md="4" class="pa-0 pr-md-3 pb-3 pb-md-0">
        <v-col class="common-card-col">
          <div class="text-h6" v-if="location_details['origin'] && location_details['destination']">
            {{ location_details["origin"]["FullName"] }} to
            {{ location_details["destination"]["FullName"] }}
          </div>
          <v-col class="px-5 py-4" v-if="location_details['origin'] && location_details['destination']">
            <div class="bottom-border pb-2 mb-4">
              <div class="d-flex justify-space-between">
                <div class="text-subtitle-2 text-capitalize">Origin</div>
                <div>
                  <v-icon>{{ location_details["origin"].IsWatchlisted ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                </div>
              </div>
              <div class="d-flex">
                <div>
                  <div class="font-weight-bold text-subtitle-2 text-capitalize">
                    {{ location_details["origin"]["FullName"] }}
                  </div>
                  <div v-if="location_details['origin']['LocationAddress1']" class="primaryGrey--text text-caption">
                    {{ $emptyCheck(location_details["origin"]["LocationAddress1"]) }}
                  </div>
                </div>
              </div>
              <div class="d-flex py-2">
                <div class="pr-4">
                  <div class="primaryGrey--text text-caption font-weight-bold">POI Category</div>
                  <div class="text-body-2">
                    {{ $emptyCheck(location_details["origin"]["LocationCategory"]) }}
                  </div>
                </div>
                <div>
                  <div class="primaryGrey--text text-caption font-weight-bold">POI Type</div>
                  <div class="text-body-2">
                    {{ $emptyCheck(location_details["origin"]["LocationType"]) }}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="d-flex justify-space-between">
                <div class="text-subtitle-2 text-capitalize">destination</div>
                <div>
                  <v-icon>{{ location_details["destination"].IsWatchlisted ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                </div>
              </div>
              <div class="d-flex">
                <div>
                  <div class="font-weight-bold text-subtitle-2 text-capitalize">
                    {{ location_details["destination"]["FullName"] }}
                  </div>
                  <div
                    v-if="location_details['destination']['LocationAddress1']"
                    class="primaryGrey--text text-caption"
                  >
                    {{ $emptyCheck(location_details["destination"]["LocationAddress1"]) }}
                  </div>
                </div>
              </div>
              <div class="d-flex py-2">
                <div class="pr-4">
                  <div class="primaryGrey--text text-caption font-weight-bold">POI Category</div>
                  <div class="text-body-2">
                    {{ $emptyCheck(location_details["destination"]["LocationCategory"]) }}
                  </div>
                </div>
                <div>
                  <div class="primaryGrey--text text-caption font-weight-bold">POI Type</div>
                  <div class="text-body-2">
                    {{ $emptyCheck(location_details["destination"]["LocationType"]) }}
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-col>
      </v-col>
      <v-col cols="12" md="8" class="pa-0">
        <v-col class="common-card-col">
          <MapsVT
            v-if="
              Object.keys(location_details['origin']).length > 0 &&
              Object.keys(location_details['destination']).length > 0
            "
            height="250px"
            :start="map_start"
            :end="map_end"
            :showRoute="showRoute"
            :hide_legends="showRoute"
          />
        </v-col>
      </v-col>
    </v-row>

    <v-row class="common-card-row pb-3">
      <v-col class="common-card-col">
        <DataTableVT
          v-if="page_content"
          :headers="page_content.devices_table"
          :items_list="device_data"
          @rowClick="open_details($event)"
          :no_search="no_search"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import MapsVT from "../components/MapsVT";
import DataTableVT from "../components/DataTableVT";
import { axios_get } from "../services/vt_service";
import { tracking } from "../services/tracking";
import { content } from "../../config/journeys.js";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];
const api_root = process.env["VUE_APP_ROOT_API"];

export default {
  props: ["JourneyID", "week"],
  watch: {
    JourneyID: function (newVal) {
      this.originId = newVal[0];
      this.destinationId = newVal[1];
      this.get_location_data(newVal, "origin", "destination");
      this.get_device_data();
    },
  },
  name: "Journey",
  components: {
    MapsVT,
    DataTableVT,
  },
  data: function () {
    return {
      flat: true,
      location_details: {
        origin: {},
        destination: {},
      },
      network_error: false,
      devices_list: [],
      originId: "",
      destinationId: "",
      weeks: "",
      device_data: [],
      current_position: {},
      current_battery_icon: "battery-full",
      has_coordinates: false,
      chartData: [],
      page_content: null,
      no_search: true,
      chartOptions: {
        chart: {
          title: "Device Signals",
          subtitle: "Messages received (last 7 days)",
        },
      },
      showRoute: true,
    };
  },
  mounted() {
    this.page_content = content;
    if (this.JourneyID) {
      this.originId = this.JourneyID[0];
      this.destinationId = this.JourneyID[1];
      this.weeks = this.week;
    }
    if (this.$route.params && this.$route.params.originId && this.$route.params.destinationId) {
      this.$store.commit("clear_search");
      this.no_search = false;
      this.originId = this.$route.params.originId;
      this.destinationId = this.$route.params.destinationId;
      this.weeks = this.$route.params.week;
      this.$store.commit("update_page_title", "Journey");
    }
    this.get_location_data([this.originId, this.destinationId], "origin", "destination");
    this.get_device_data();
  },
  methods: {
    async get_location_data(locationId, key1, key2) {
      const accessToken = await this.$auth.getTokenSilently();
      this.network_error = false;
      var self = this;
      const tenant = this.$auth.user[tenant_key]["tenant"];
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };
      let location_origin_req = axios.get(api_root + "/api/location/" + locationId[0], header);
      let location_dest_req = axios.get(api_root + "/api/location/" + locationId[1], header);
      let watchlist_req = axios.get(api_root + "/api/watchlist/location", header);
      axios
        .all([location_origin_req, location_dest_req, watchlist_req])
        .then(
          axios.spread((...responses) => {
            self.location_details[key1] = responses[0].data[0];
            self.location_details[key2] = responses[1].data[0];
            let watchlisted = responses[2].data.map((elem) => elem["LocationID"]);
            self.location_details[key1]["IsWatchlisted"] =
              watchlisted.indexOf(self.location_details[key1]["LocationID"]) == -1 ? false : true;
            self.location_details[key2]["IsWatchlisted"] =
              watchlisted.indexOf(self.location_details[key2]["LocationID"]) == -1 ? false : true;
          })
        )
        .catch((e) => {
          self.network_error = true;
          console.log(e);
        });
    },
    async get_device_data() {
      this.network_error = false;
      const response = await axios_get(tracking.get_journey_device_data, {
        originId: this.originId,
        destinationId: this.destinationId,
        weeks: this.weeks,
      });
      this.device_data = response;
    },
    filter_journeys_list() {
      return this.devices_list.filter((elem) => elem.DeviceID == this.deviceId);
    },
  },
  computed: {
    map_start: function () {
      return this.location_details && this.location_details["origin"]
        ? `${this.location_details["origin"].Latitude},${this.location_details["origin"].Longitude}`
        : null;
    },
    map_end: function () {
      return this.location_details && this.location_details["destination"]
        ? `${this.location_details["destination"].Latitude},${this.location_details["destination"].Longitude}`
        : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.journey_details .title {
  font-size: 0.75rem !important;
  font-family: Trade Gothic Regular !important;
}
div.bottom-border {
  border-bottom: 1px solid var(--v-restingOutline-base);
}
div.right-border {
  border-right: 1px solid var(--v-restingOutline-base);
}
.device_details .title {
  font-size: 0.75rem !important;
  font-family: Trade Gothic Regular !important;
}
</style>
